const videoDivs = document.querySelectorAll('.js-video-default, .js-video-with-content');

const getYoutubeThumbUrl = (videoUrl, size) => {
    let video, results;

    if (videoUrl === null) {
        return '';
    }

    size = (size === null) ? 'big' : size;
    results = videoUrl.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);
    video = (results && results[7].length == 11) ? results[7] : videoUrl;

    if (size === 'small') {
        return 'https://img.youtube.com/vi/' + video + '/1.jpg';
    }

    return 'https://img.youtube.com/vi/' + video + '/hqdefault.jpg';
};

const insertImageElementToDom = (el, img) => {
    el.querySelector('.js-video-placeholder').insertBefore(
        img,
        el.querySelector('.js-video-content')
    );
};

const addImageIfNeeded = (videoDiv) => {
    const videoLink = videoDiv.dataset.video;
    const videoType = videoDiv.dataset.videotype;

    const alreadyHasImage = videoDiv.querySelector('img');
    if (alreadyHasImage) {
        return;
    }

    const img = document.createElement("img");
    if (videoType === 'youtube') {
        img.src = getYoutubeThumbUrl(`${videoLink}`, 'big');
        insertImageElementToDom(videoDiv, img);
        return;
    }

    img.classList.add('video-image-placeholder');
    insertImageElementToDom(videoDiv, img);
};

function handleDefaultVideoClick(e) {
    const el = e.currentTarget;
    const placeholderEl = el.querySelector('.js-video-placeholder');
    const iframeWrapperEl = el.querySelector('.js-video-iframe-wrapper');
    if (!placeholderEl || !iframeWrapperEl) return;

    placeholderEl.classList.add('hidden');
    iframeWrapperEl.classList.remove('hidden');

    const iframeEl = iframeWrapperEl.querySelector('iframe');
    iframeEl.src = iframeEl.dataset.src;
}

[].forEach.call(videoDivs, (video) => {
    addImageIfNeeded(video);

    const isDefaultVideo = video.classList.contains('js-video-default');
    if (isDefaultVideo) {
        video.addEventListener('click', handleDefaultVideoClick)
    }
});